module.exports = __webpack_public_path__ + "img/30-CASACCA-FANTASIA-U-COLORI-GARZA-COLORI-RETE-PANTALONE-MUSA-SMLXL-COLORI-GARZA-COLORI-RETE3.1e6f48ae.jpg";